// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3Tx1A","row":"styles_row__MzAXJ"};